import { render, staticRenderFns } from "./AddErrorReport.vue?vue&type=template&id=96f5a076&"
import script from "./AddErrorReport.vue?vue&type=script&lang=js&"
export * from "./AddErrorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports